import {Link} from "react-router-dom";
import * as BsIcons from "react-icons/bs";
import {forwardRef, useImperativeHandle, useRef} from "react";
import LangChanger from "./LangChanger.tsx";

interface ContentProps {
    toggleSidebar?: () => void;
}

export type NavbarRef = HTMLDivElement;
export const Navbar = forwardRef<NavbarRef, ContentProps>(
    ({toggleSidebar}, ref) => {
        const divRef = useRef<HTMLDivElement>(null);
        useImperativeHandle(ref, () => divRef.current!)

        if (toggleSidebar) {
            return (
                <div className="navbar d-flex flex-wrap pb-4" ref={divRef}>
                    <Link to="#" className="px-4 text-black" onClick={toggleSidebar}>
                        <BsIcons.BsList size="17"/>
                    </Link>

                    <LangChanger />
                </div>
            )
        }

        return (
            <></>
        )
    }
)
